<template>
	<section class="pc-card" v-if="data.length > 0">
		<h2 class="pc-card-title">老師媒體</h2>
		<ul>
			<li v-for="item in data" :key="item.id" @click="goLink(item.jump_url)">
				<img :src="item.cover_cc || item.cover" alt="" />
				<div class="title">{{ item.name }}</div>
			</li>
		</ul>
	</section>
</template>

<script setup>
import { goLink } from "~/utils/common";

const props = defineProps({
	data: {
		type: Object,
		default: () => ({}),
	},
});
</script>

<style lang="scss" scoped>
.pc-card {
	margin-top: 30px;
	padding: 0 63px;
	font-family: PingFang SC;

	.pc-card-title {
		margin: 12px 20px 0;
		font-weight: 400;
		font-size: 32px;
		color: #1f2329;
	}

	.title,
	.desc {
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	ul {
		display: flex;
		align-items: center;
		margin-top: 24px;
		padding: 0 80px;
		width: 1154px;
		height: 147px;
		background: #ffffff;
		border-radius: 8px 8px 8px 8px;

		li {
			margin-right: 110px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			width: 111px;
			height: 123px;
			border-radius: 6px;
			background-color: #ffffff;
			cursor: pointer;

			&:last-child {
				margin-right: 0;
			}

			img {
				width: 65px;
				height: 65px;
			}

			.title {
				// margin-top: 12px;
				font-weight: 500;
				font-size: 22px;
				color: #2b2f36;
				line-height: 30px;
			}
		}
	}
}
</style>
